import PropTypes from 'prop-types';

import { NS } from '@/constants';

import Form from '@/components/common/form/Form';
import FormField from '@/components/common/form/FormField';

import styles from './TimeSlotSelector.module.scss';
import { FIELD_TYPE } from '@/constants/form';

const slotOptions = (timeSlots, locale) => {
  const options = timeSlots?.map((slot) => {
    const start = (new Date(slot.start)).toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' });
    const end = (new Date(slot.end)).toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' });
    return {
      label: `${start} - ${end}`,
      value: `${slot.start}|${slot.end}`
    };
  });

  options.unshift({ label: '', value: '' });

  return options;
};

export const TimeSlotSelector = ({ t, formId, timeSlots, onSubmit, locale, defaultValues, selectedSlot, isDayOnly }) => (
  <Form id={formId} onSubmit={onSubmit} defaultValues={defaultValues}>
    {!isDayOnly && (
      <>
        <p className={styles.subtitle}>{t('shipMode.topChrono.availableSlots')}</p>
        <FormField
          type={FIELD_TYPE.SELECT}
          name="slot"
          options={slotOptions(timeSlots, locale)}
          isRequired
          placeholder={t('shipMode.topChrono.selectSlot')}
          selected={selectedSlot}
        />
      </>
    )}
    <p className={styles.subtitle}>{t('shipMode.topChrono.contactInformation')}</p>
    <FormField
      id="profile-phone"
      name="phoneNumber"
      label={t('forms.phone', { ns: NS.COMMON })}
      type={FIELD_TYPE.PHONE}
      isWithCountrySelector={true}
      isRequired
      placeholder={t('shipMode.topChrono.phonePlaceholder')}
      data-test-id="phone"
    />
    <p>{t('shipMode.topChrono.willContactYou')}</p>
  </Form>
);

TimeSlotSelector.propTypes = {
  t: PropTypes.func.isRequired,
  formId: PropTypes.string.isRequired,
  timeSlots: PropTypes.array.isRequired,
  locale: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  defaultValues: PropTypes.object,
  selectedSlot: PropTypes.object,
  isDayOnly: PropTypes.bool,
};

export default TimeSlotSelector;
